export const QUESTION_TYPES = {
	RATING: "RATING",
	SINGLE_SELECT: "SINGLE_SELECT",
	MULTI_SELECT: "MULTI_SELECT",
	TEXT_INPUT: "TEXT_INPUT",
	TEXT_AREA: "TEXT_AREA",
};

export const MAND_PAYLOAD_DATA = ['requestType', 'lob', 'journey', 'customerInformation', 'requesterInformation']

export const FEEDBACK_PAYLOAD_MAP = {
	requestType: "SKELETON",
	journey: "ATB_2.0",
	lob: null,
	partyId: null,
	customerInformation: { emailId: '', userName: '', communicationNumber: '', olmId: '' },
	requesterInformation: { emailId: '', userName: '', communicationNumber: '', olmId: '' },
	product: null,
	circle: null,
	segment: null,
	channel: null,
	channelId: null,
	journeyIdentifier: null,
}

export const VIEW_TYPE_MAP = {
	SMALL: "small",
	LARGE: "large",
	MODAL: "Modal"
}